<li class="post">
    <div class="post__author" v-if="postImg">
        <div class="post__img loading" v-if="!isImgLoaded">
           <icon name="imgSpinner" />
        </div>
        <img
                :src="postImg" alt="avatar" class="post__img"
                v-show="isImgLoaded" @load="imgLoaded">
        <h3 class="post__nickname">{{username}}</h3>
    </div>
    <framework
            :title="frameworkName"
            :span="frameworkSpan"
            :desc="frameworkDesc"
            :stars="stars"
            :forks="forks"
            @change="onChange"
    />

    <issues
            v-if="issuesNum > 0"
            :num="issuesNum"
            :framework-name="frameworkName"
            :loading="issues?.loading"
            :error="issues?.error"
            :current-info="checkStateByRepo(frameworkName)"
            @loadIssues="getIssues"
    />

    <time class="post__date" v-if="month && numMonth">{{numMonth}} {{month}}</time>
</li>
